import moment from "moment";
export default function formAPIuserdetails({
  firstname,
  lastname,
  fullname,
  gender,
  dob,
  regdate,
  profilepictureurl,
  mobileno,
  email,
  countryid,
  ratings,
  isuserdoctor,
  issuperuser,
  roleid,
  isfirsttimelogin,
  rolename,
  imagepath,
  templateid,
  templatevalue,
  doctorspeciality
   

})
{
  return Object.freeze({
    firstname,
    lastname,
    fullname,
    gender,
    dob,
    regdate,
    profilepictureurl,
    mobileno,
    email,
    countryid,
    ratings,
    isuserdoctor,
    issuperuser,
    roleid,
    isfirsttimelogin,
    rolename,
    imagepath,
    templateid,
    templatevalue,
    doctorspeciality
  
  });
}